import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import {
  getMemberProgress,
  clearProgress,
} from "../../store/ducks/dailyCheckIn/actions";
import MemberProgress from "./MemberProgress";
import Swal from "sweetalert2";
import { Icon } from "@iconify/react";


class DailyCheckIn extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.clearProgressResult !== this.props.clearProgressResult &&
      this.props.clearProgressResult.responseCode === 200
    ) {
      const { t } = this.props;

      Swal.fire({
        icon: "success",
        title: t("global.success"),
        html: this.props.clearProgressResult.message[0],
        showConfirmButton: true,
        confirmButtonText: t("global.ok"),
      }).then(() => {
        this.props.getMemberProgress();
      });
    }
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;
    const img = this.imageImport(require.context("../../assets/images/check-in", false, /\.(png|jpe?g|svg|webp)$/));

    return (      
      <>
        <div className="daily-check-in-bg-overlay"></div>
      
        <div
          className="daily-check-in-modal"
        >
          <img className="flare-light" src={img["shine.webp"]} alt="flare light" />
          <img className="modal-bg" src={img['daily-check-in-bg.webp']} alt="daily check in"/>
          <div className="modal-title">
            <h2>{t('check_in.daily-check-in')}</h2>
            <p>{t('check_in.rewards-start-here')}</p>
          </div>

            <MemberProgress />            
            <div className="d-flex justify-content-center">
              <Icon type="button" className="btn-close text-white" icon="si:close-circle-duotone" onClick={() => this.props.onCloseMemberProgress()} />
            </div>
          </div>                                
      </>
    );
  }
}

const mapStateToProps = (reduxState) => {
  return {
    clearProgressResult: reduxState.dailyCheckIn?.clearProgress?.data|| {},
  };
};

const mapDispatchToProps = {
  clearProgress,
  getMemberProgress,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(DailyCheckIn));
